// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1fvTX","ranges":"BmiRanges_ranges__x09YC"};